import GetAppIcon from "@mui/icons-material/GetApp";
import { Button, Checkbox } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx";

import { actionTypes as listActionType } from "redux/offlineorder/select_offline_orders_history";

import DataTable from "common/components/dataTable";

const OfflineOrdersHistory = () => {
  const reducerData = useSelector(
    (state) => state.select_offline_orders_history_Reducer,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: listActionType.selectOfflineOrdersHistoryAsync,
      payload: {},
    });
  }, []);

  const columns = [
    {
      label: "قیمت",
      field: "price",
      searchable: false,
      sortable: false,
      type: "number",
    },
    {
      label: "تعداد",
      field: "quantity",
      searchable: false,
      sortable: false,
      type: "number",
    },
    {
      label: "نوع معامله",
      field: "side",
      searchable: false,
      sortable: true,
      type: "option",
      format: (data) => statusOfSide(data),
    },
    {
      label: "تاریخ و زمان اجرا",
      field: "trigger_datetime",
      searchable: false,
      sortable: true,
      type: "date",
    },

    {
      label: "نام نماد",
      field: "symbol",
      searchable: true,
      sortable: true,
    },

    {
      label: "مقدار سفارش",
      field: "order_value",
      searchable: false,
      sortable: false,
      type: "number",
    },
    {
      label: "خطا دارد",
      field: "is_successful",
      searchable: false,
      sortable: true,
      type: "option",
      format: (data) => (
        <Checkbox
          color="error"
          checked={data === "TRUE"}
          readOnly
          style={{
            width: "20px",
            height: "20px",
            cursor: "not-allowed",
          }}
        />
      ),
    },

    {
      label: "علت خطا",
      field: "description",
      searchable: false,
      sortable: false,
    },
  ];

  const handleDownloadExcel = () => {
    const header = columns.map((col) => col.label);

    const excelData = reducerData?.data?.results.map((row) =>
      columns.map((col) => row.body[col.field]),
    );

    const ws = XLSX.utils.aoa_to_sheet([header, ...excelData]);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "marketer");
    XLSX.writeFile(wb, "marketer_data.xlsx");
  };
  const statusOfSide = (key) => {
    switch (key) {
      case "BUY":
        return "خرید";
      case "SELL":
        return "فروش";
      default:
        return "-";
    }
  };
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "20px 0",
        }}
      >
        <div></div>
        <Button
          style={{ maxWidth: 200 }}
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          onClick={handleDownloadExcel}
        >
          دانلود اکسل
        </Button>
      </div>
      <div>
        <DataTable
          columns={columns}
          data={reducerData?.data?.results}
          actionLabel="بررسی عملکرد"
          pageSize={10}
          isLoading={reducerData?.loading}
        />
      </div>
    </div>
  );
};

export default OfflineOrdersHistory;
